import { useSenderScore as useSenderScoreFromApi } from '@/src/infrastructure/services/useSenderScore';

import { useSenderScoreWithPostMessage } from './useSenderScoreWithPostMessage';
import { useWithCompat } from './useWithCompat';

export const useSenderScore = (senderScore?: number) => {
  return useWithCompat(useSenderScoreFromApi, useSenderScoreWithPostMessage, senderScore);
};
